
import { initializeApp,getApps } from "firebase/app";
import { getDatabase, ref, push,goOffline,goOnline } from "firebase/database";



const firebaseConfig = {
  apiKey             : "AIzaSyDwU_qR5f450wehl5M_hFmBvFFSmdM-ZPg",
  authDomain         : "studiopush-3d832.firebaseapp.com",
  projectId          : "studiopush-3d832",
  storageBucket      : "studiopush-3d832.firebasestorage.app",
  messagingSenderId  : "312620526932",
  appId              : "1:312620526932:web:8d955d9b4a65a0a68d6cc1",
  measurementId      : "G-V6E0NFSMJB",
  databaseURL        : "https://studiopush-3d832-default-rtdb.europe-west1.firebasedatabase.app/", // <--- IMPORTANTE
};



// Inizializza Firebase

//const app = initializeApp(firebaseConfig);
//export const db = getDatabase(app);

/*
goOffline(db);
goOnline(db)
*/


const app = getApps().length === 0 
  ? initializeApp(firebaseConfig) 
  : getApps()[0];

export const db = getDatabase(app);



export const addBooking = (data) => { 

  push(ref(db, "bookings"), data)
  console.log('Push Booking effettuato.')
} 

export const addMessage = (data) => { 

  push(ref(db, "messages"), data)
  console.log('Push Messaggio effettuato.')
} 